import React, {PureComponent, ReactNode} from 'react';
import {scrollToTop} from 'app/utils';
import SystemCard from './SystemCard';
import {getDepositComponent} from './DepositComponents';
import PaymentSystemInterface from 'app/interfaces/PaymentSystemInterface';
import {inject, observer} from 'mobx-react';
import P2pDepositsStoreProps from 'app/store/P2pDepositsStoreProps';
import {DepositsStoreProps} from 'app/store/DepositsStore';

interface SystemProps extends P2pDepositsStoreProps, DepositsStoreProps {
    system: PaymentSystemInterface,
    selectSystem(system: PaymentSystemInterface): void
}

@inject('depositsStore', 'p2pDepositsStore')
@observer
export default class System extends PureComponent<SystemProps> {
    selectSystem = (): void => {
        const {system, selectSystem} = this.props;
        selectSystem(system);
        scrollToTop();
    };

    render(): ReactNode {
        const {system, system: {deposit_ui_component, slug}} = this.props;
        const activeSystemClass = this.props.depositsStore.currentPaymentSystem?.slug === slug ? 'active' : '';

        if (!getDepositComponent(deposit_ui_component)) {
            return null;
        }

        return <div
            onClick={this.selectSystem}
            className={`payment-systems__deposit__item payment-systems__deposit-recommended__item ${activeSystemClass}`}
        >
            <SystemCard system={system}/>
        </div>;
    }
}
